@if (message) {
  <span [class]="icon.class">
    <rma-icon [glyph]="icon.icon" />
  </span>
  @if (isHtml) {
    <span class="break-words" [innerHtml]="message"></span>
  } @else {
    <span class="break-words">{{ message }}</span>
  }
  @if (dismissible) {
    <button class="!flex !items-center" (click)="dismiss.emit()" type="button">
      <rma-icon glyph="clear" />
    </button>
  }
}
